module.exports = __webpack_public_path__ + "img/result-detail-invest-outright03.47fa022b.svg";